export const CUSTOMER_RESULTS_CATEGORIES = {
    BLOOD_CATEGORY: 1,
    DNA_CATEGORY: 2,
    FOOD_INTOLERANCE_CATEGORY: 3
}

export const CATEGORY_LABELS = {
    [CUSTOMER_RESULTS_CATEGORIES.BLOOD_CATEGORY]: "Blood",
    [CUSTOMER_RESULTS_CATEGORIES.DNA_CATEGORY]: "DNA",
    [CUSTOMER_RESULTS_CATEGORIES.FOOD_INTOLERANCE_CATEGORY]: "Food Intolerance",
}

export const HEALF_ORG_ID = 2;

export const RETEST_REQUEST_STATUSES = {
    NOT_STARTED: "notStarted",
    CREATE: "create",
    PENDING: "pending",
    ACTIVATED: "activated",
    CANCELLED: "cancelled"
};

export const RETEST_STATUS_CODES = {
    ALL: 0,
    NOT_STARTED: 1,
    PENDING: 2,
    ACTIVATED: 3,
    CANCELLED: 4
}

export const RETEST_STATUS_LABELS = {
    [RETEST_REQUEST_STATUSES.NOT_STARTED]: "Not Started",
    [RETEST_REQUEST_STATUSES.CREATE]: "Create",
    [RETEST_REQUEST_STATUSES.PENDING]: "Pending Activation",
    [RETEST_REQUEST_STATUSES.ACTIVATED]: "Activated",
    [RETEST_REQUEST_STATUSES.CANCELLED]: "Cancelled"
};

export const RETEST_STATUS_OPTIONS = {
    [RETEST_STATUS_CODES.ALL]: "All",
    [RETEST_STATUS_CODES.NOT_STARTED]: "Not Started",
    [RETEST_STATUS_CODES.PENDING]: "Pending Activation",
    [RETEST_STATUS_CODES.ACTIVATED]: "Activated",
    [RETEST_STATUS_CODES.CANCELLED]: "Cancelled"
}
